import { Loader, ThemeProvider } from '@pw-tech/omni-ui';
import { FlagProvider } from '@unleash/proxy-client-react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import QueryClientWrapper from './lib/QueryClientWrapper';
import { ReduxProviders } from './lib/redux/providers';
import useAppConfig, { updateWebSdkConfig } from './lib/useAppConfig';
import { isOTT } from './lib/utilities';
import PwWebSDKInstance from './services/pwWebSDKService';
import { UnleashConfig } from './services/unleashService';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const unleashConfig = UnleashConfig.getInstance().config;
const isDarkThemeEnabled = isOTT();

if (['prod'].includes(process.env.REACT_APP_ENVIRONMENT || '')) {
  console.log = console.error = console.debug = () => {};
}

const ThemeWrapper: React.FC = () => {
  const { appTheme, appConfig, data } = useAppConfig();
  const [isAppInitialized, setIsAppInitialized] = useState(false);

  useEffect(() => {
    const init = async () => {
      if (data && PwWebSDKInstance) {
        updateWebSdkConfig(appConfig || null, PwWebSDKInstance).then(() =>
          setIsAppInitialized(true),
        );
      }
    };

    init();
  }, [data, PwWebSDKInstance]);

  return (
    <ThemeProvider theme={appTheme || {}} colorScheme={isDarkThemeEnabled ? 'dark' : undefined}>
      {!isAppInitialized ? (
        <Loader color='static-black' />
      ) : (
        <>
          <div className='!z-[99999]' id='pw_auth-flow' />
          <QueryClientWrapper>
            <ReduxProviders>
              <FlagProvider config={unleashConfig}>
                <App />
              </FlagProvider>
            </ReduxProviders>
          </QueryClientWrapper>
        </>
      )}
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<ThemeWrapper />);

serviceWorkerRegistration.register();
